import React, { forwardRef } from 'react';
import { TableEditableCell as EdsTableEditableCell } from '@hedtech/react-design-system/core/es/Table';
const TableEditableCell = (props, ref) => (React.createElement(EdsTableEditableCell, Object.assign({ ref: ref }, props)));
const TableEditableCellFRC = forwardRef(TableEditableCell);
TableEditableCellFRC.displayName = 'TableEditableCellFRC';
export default TableEditableCellFRC;
